import { render } from 'preact';
import './styles.css';
import { App } from './app';

render(<App />, document.getElementById('app')!);
